import { call, put } from "redux-saga/effects";
import {
  fetchFeaturedDeals,
  fetchBannerDeals,
  fetchFavoritesNearby,
  fetchTopOnlineDeals,
  fetchPopularBrands,
  fetchRecommendations,
  fetchHotDeals,
  fetchOurPickEatPlayShop,
  fetchOurPickThemePark,
} from "@Api/campaignsApi.js";
import { mapFromRecommendations } from "../reducers/campaignReducer";
import { Types } from "../actionTypes";

export function* doGetFavoritesNearby(action) {
  try {
    const response = yield call(fetchFavoritesNearby, action.location);

    yield put({ type: Types.FETCH_FAVORITES_NEARBY_SUCCESS, response });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_FAVORITES_NEARBY_FAILURE, error });
  }
}

export function* doGetRecommendations() {
  try {
    const data = yield call(fetchRecommendations);
    let mapped = data.recommendations
      .map((group) => mapFromRecommendations(group.recommendations))
      .flat();
    yield put({
      type: Types.FETCH_RECOMMENDATIONS_SUCCESS,
      response: mapped,
    });
  } catch (error) {
    yield put({ type: Types.FETCH_RECOMMENDATIONS_FAILURE, error });
  }
}

export function* doGetPopularBrands(action) {
  try {
    const response = yield call(fetchPopularBrands, action.location);

    yield put({ type: Types.FETCH_POPULAR_BRANDS_SUCCESS, response });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_POPULAR_BRANDS_FAILURE, error });
  }
}

export function* doGetBannerDeals(action) {
  try {
    const response = yield call(fetchBannerDeals, action.params);

    yield put({ type: Types.FETCH_BANNER_DEALS_SUCCESS, response });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_BANNER_DEALS_FAILURE, error });
  }
}

export function* doGetFeaturedDeals(action) {
  try {
    const response = yield call(fetchFeaturedDeals, action.params);
    yield put({ type: Types.FETCH_FEATURED_DEALS_SUCCESS, response });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_FEATURED_DEALS_FAILURE, error });
  }
}

export function* doGetHotDeals(action) {
  try {
    const response = yield call(fetchHotDeals);
    yield put({ type: Types.FETCH_HOT_DEALS_SUCCESS, response });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_HOT_DEALS_FAILURE, error });
  }
}

export function* doGetOurPicks(action) {
  try {
    const eatPlayShopResponse = yield call(fetchOurPickEatPlayShop);
    const themeParksResponse = yield call(fetchOurPickThemePark);
    yield put({
      type: Types.FETCH_OUR_PICKS_SUCCESS,
      response: {
        eatPlayShop: eatPlayShopResponse?.stores,
        themeParks: themeParksResponse?.stores,
      },
    });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_OUR_PICKS_FAILURE, error });
  }
}

export function* doGetTopOnlineDeals(action) {
  try {
    const response = yield call(fetchTopOnlineDeals, action.params);

    yield put({ type: Types.FETCH_TOP_ONLINE_DEALS_SUCCESS, response });
  } catch (error) {
    console.error(error);

    yield put({ type: Types.FETCH_TOP_ONLINE_DEALS_FAILURE, error });
  }
}
